import React, { useState } from "react";
import { Share2, Copy, Crown, Ban } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const shareUrl = (t) => `${window.location.origin}/share/${t}`;

const ApprovalRow = ({ a, projectId, onChange }) => {
  const best = Object.entries(a.tally).sort((x, y) => y[1] - x[1])[0];
  const copy = () => { navigator.clipboard?.writeText(shareUrl(a.token)); toast.success("Link copied"); };
  const useWinner = async () => { await api.activateSnapshot(projectId, best[0]); toast.success("Couple's pick is now the render look"); onChange(); };
  const revoke = async () => { await api.revokeApproval(projectId, a.id); toast.success("Link revoked"); onChange(); };
  return (
    <div className={`studio-card p-4 space-y-2 ${a.active ? "" : "opacity-50"}`} data-testid={`approval-${a.id}`}>
      <div className="flex items-center gap-2 flex-wrap">
        <span className="font-semibold text-sm flex-1">{a.title}</span>
        {a.active && <button className="btn btn-ghost !py-1 text-xs" onClick={copy} data-testid={`approval-copy-${a.id}`}><Copy size={12} />Copy link</button>}
        {best && <button className="btn btn-gold !py-1 text-xs" onClick={useWinner} data-testid={`approval-use-winner-${a.id}`}><Crown size={12} />Use couple's pick</button>}
        {a.active && <button className="btn btn-danger !py-1 text-xs" onClick={revoke} data-testid={`approval-revoke-${a.id}`}><Ban size={12} />Revoke</button>}
      </div>
      <div className="font-mono text-[11px] text-[#5fe9f5] break-all" data-testid={`approval-url-${a.id}`}>{shareUrl(a.token)}</div>
      <div className="flex gap-3 flex-wrap text-xs">
        {a.looks.map((l) => <span key={l.id} className="chip bg-[#252A3B] text-[#CBD5E1]" data-testid={`approval-tally-${a.id}-${l.id}`}>{l.name}: {a.tally[l.id] || 0} vote(s)</span>)}
      </div>
      {a.votes.filter((v) => v.comment).map((v) => (
        <p key={v.voter_id} className="text-xs text-[#94A3B8]"><b>{v.name}</b> → {a.looks.find((l) => l.id === v.snapshot_id)?.name}: “{v.comment}”</p>
      ))}
    </div>
  );
};

export const ClientApproval = ({ projectId, snaps, clips, approvals, onChange }) => {
  const [sel, setSel] = useState([]);
  const [frames, setFrames] = useState([]);
  const [msg, setMsg] = useState("");
  const tog = (arr, set, id, max) => set(arr.includes(id) ? arr.filter((x) => x !== id) : arr.length >= max ? arr : [...arr, id]);
  const create = async () => {
    try { const a = await api.createApproval(projectId, { snapshot_ids: sel, media_ids: frames, message: msg }); navigator.clipboard?.writeText(shareUrl(a.token)); toast.success("Share link created & copied"); setSel([]); setMsg(""); onChange(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  return (
    <div className="space-y-3" data-testid="client-approval">
      <div className="studio-card p-4 space-y-3">
        <div className="metric-label">Looks to share (2–4)</div>
        <div className="flex flex-wrap gap-2">{snaps.map((s) => (
          <button key={s.id} onClick={() => tog(sel, setSel, s.id, 4)} data-testid={`approval-look-${s.id}`}
            className={`chip ${sel.includes(s.id) ? "bg-[#E6B04E] text-[#1a1405]" : "bg-[#252A3B] text-[#CBD5E1]"}`}>{s.name}</button>))}
          {snaps.length < 2 && <span className="text-xs text-[#64748B]">Save at least 2 looks above first.</span>}
        </div>
        <div className="metric-label">Preview frames (1–3 clips)</div>
        <div className="flex flex-wrap gap-2 max-h-24 overflow-y-auto">{clips.map((c) => (
          <button key={c.id} onClick={() => tog(frames, setFrames, c.id, 3)} data-testid={`approval-frame-${c.id}`}
            className={`chip ${frames.includes(c.id) ? "bg-[#00F0FF] text-[#04262a]" : "bg-[#252A3B] text-[#CBD5E1]"}`}>{c.filename}</button>))}
        </div>
        <input value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="Note to the couple (optional)" className="studio-input !py-1.5 text-sm" data-testid="approval-message" />
        <button className="btn btn-gold !py-1.5 text-sm" disabled={sel.length < 2 || !frames.length} onClick={create} data-testid="btn-create-approval"><Share2 size={14} />Create share link</button>
      </div>
      {approvals.map((a) => <ApprovalRow key={a.id} a={a} projectId={projectId} onChange={onChange} />)}
    </div>
  );
};
